import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=9fa7be00&scoped=true"
import script from "./Incidents.vue?vue&type=script&lang=js"
export * from "./Incidents.vue?vue&type=script&lang=js"
import style0 from "./Incidents.vue?vue&type=style&index=0&id=9fa7be00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fa7be00",
  null
  
)

export default component.exports